// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Box from "../../resources/layout-and-structure/Box.res.js";
import * as I18n from "../../primitives/I18n.res.js";
import * as Page from "../../resources/layout-and-structure/Page.res.js";
import * as Stack from "../../resources/layout-and-structure/Stack.res.js";
import * as React from "react";
import * as Notifier from "../../bundles/Notifier/Notifier.res.js";
import * as Stdlib_Option from "@rescript/runtime/lib/es6/Stdlib_Option.js";
import * as JsxRuntime from "react/jsx-runtime";
import * as Primitive_exceptions from "@rescript/runtime/lib/es6/Primitive_exceptions.js";
import * as CatalogVariantEditFormPageActions from "../../modules/Catalog/CatalogVariantEditFormPageActions.res.js";
import * as CatalogVariantEditFormStockFieldsetPanel from "../../modules/Catalog/CatalogVariantEditFormStockFieldsetPanel.res.js";
import * as CatalogVariantEditFormRetailPriceTablePanel from "../../modules/Catalog/CatalogVariantEditFormRetailPriceTablePanel.res.js";
import * as CatalogVariantEditFormPurchasePriceTablePanel from "../../modules/Catalog/CatalogVariantEditFormPurchasePriceTablePanel.res.js";
import * as CatalogVariantEditFormInformationFieldsetPanel from "../../modules/Catalog/CatalogVariantEditFormInformationFieldsetPanel.res.js";

let CatalogVariantEditPage__CouldNotMakeTitle = /* @__PURE__ */Primitive_exceptions.create("CatalogVariantEditPage.CatalogVariantEditPage__CouldNotMakeTitle");

function CatalogVariantEditPage(props) {
  let productValues = props.productValues;
  let shopName = props.shopName;
  let formattedName = props.formattedName;
  let editionMode = props.editionMode;
  let notifier = Notifier.use(undefined, undefined);
  let renderActions = () => JsxRuntime.jsx(CatalogVariantEditFormPageActions.make, {
    editionMode: editionMode,
    productValues: productValues
  });
  let formattedTitle;
  if (editionMode) {
    if (productValues !== undefined) {
      throw {
        RE_EXN_ID: CatalogVariantEditPage__CouldNotMakeTitle,
        Error: new Error()
      };
    }
    formattedTitle = I18n.t("Editing") + " " + formattedName;
  } else {
    formattedTitle = productValues !== undefined ? I18n.template(I18n.t("Step {{step}} | Create {{fulfill}}"), {
        step: "2",
        fulfill: I18n.t("a variant")
      }, undefined) : I18n.t("Create a new variant");
  }
  let formattedSubtitle = editionMode ? shopName : shopName + " - " + formattedName;
  return JsxRuntime.jsxs(Page.make, {
    children: [
      JsxRuntime.jsx(Notifier.Banner.make, {
        notifier: notifier
      }),
      JsxRuntime.jsx(Box.make, {
        children: JsxRuntime.jsxs(Stack.make, {
          children: [
            JsxRuntime.jsx(CatalogVariantEditFormInformationFieldsetPanel.make, {
              editionMode: editionMode,
              productKind: props.productKind
            }),
            editionMode ? null : JsxRuntime.jsxs(Stack.make, {
                children: [
                  JsxRuntime.jsx(CatalogVariantEditFormPurchasePriceTablePanel.make, {}),
                  JsxRuntime.jsx(CatalogVariantEditFormRetailPriceTablePanel.make, {
                    taxRate: Stdlib_Option.getOr(props.productTaxRate, 20)
                  }),
                  JsxRuntime.jsx(CatalogVariantEditFormStockFieldsetPanel.make, {})
                ],
                space: "large"
              })
          ],
          space: "large"
        }),
        spaceTop: "large"
      })
    ],
    title: formattedTitle,
    subtitle: formattedSubtitle,
    renderActions: renderActions
  });
}

let make = React.memo(CatalogVariantEditPage);

let Config;

export {
  Config,
  CatalogVariantEditPage__CouldNotMakeTitle,
  make,
}
/* make Not a pure module */
